// Parses a "YYYY-MM-DD" plan-entry date string into a local Date at midnight.
// `new Date(date_string)` parses that format as UTC, which can shift the calendar
// day by one in negative-UTC-offset timezones — this avoids that.
export function parseLocalDate(date_string) {
    let [year, month, day] = date_string.split('-');
    return new Date(Number(year), Number(month) - 1, Number(day));
}
